export const prizes = [
  {
    days: 16,
    reward: "Ящик напою",
    icon: "/img/icons/drink.svg",
    value: "16 днів",
  },
  {
    days: 25,
    reward: "Навушники JBL",
    icon: "/img/icons/headphones.svg",
    value: "25 днів",
  },
  {
    days: 60,
    reward: "Відпустка 2 дні",
    icon: "/img/icons/vacation.svg",
    value: "60 днів",
  },
];

export const currentDays = 42;
